import React from 'react'
import { Button, Icon, Select } from 'semantic-ui-react'

interface OptionalSelectProps {
  isEditing: boolean
  onClick: () => void
  onChange: (x: string) => void
  options: { key: string; value: string; text: string }[]
  placeholder: string
  inputName: string
  value: string
}

const OptionalSelect = (props: OptionalSelectProps) => {
  const { inputName, isEditing, onClick, onChange, options, placeholder } = props
  return (
    <>
      <Button color={'teal'} onClick={() => onClick()} style={{ opacity: isEditing ? '1' : '.5' }}>
        <Icon name="pencil" />
        {!isEditing ? `Edit ${inputName}` : 'Cancel Edit'}
      </Button>
      <Select
        disabled={!isEditing}
        options={options}
        placeholder={placeholder}
        // @ts-ignore
        onChange={(e, { value }) => onChange(value)}
      />
    </>
  )
}

export default OptionalSelect
